<form (ngSubmit)="submit()" class="search-container">
  @if (searchAfterSubmit) {
    <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
      <input
        type="text"
        [(ngModel)]="searchValue"
        name="search-value"
        nz-input
        placeholder="Suchtext eingeben"
        [attr.aria-label]="ariaLabel"
        />
    </nz-input-group>
  } @else {
    <nz-input-group nzSearch>
      <input
        type="text"
        [(ngModel)]="searchValue"
        (ngModelChange)="searchValueChanged()"
        (blur)="removeSubscription()"
        name="search-value"
        nz-input
        placeholder="Suchtext eingeben"
        [attr.aria-label]="ariaLabel"
        />
    </nz-input-group>
  }

  <ng-template #suffixIconButton>
    <button
      type="submit"
      nz-button
      nzType="primary"
      nzSearch
      aria-label="Suche"
      >
      <i
        nz-icon
        nzType="search"
      ></i>
    </button>
  </ng-template>
</form>
